export const getRedirectRoute = state => state.redirectReducer.route;
